import { publicFetch } from "./client";

/**
 * Creates a guest session for anonymous users.
 * Every public client should call this on startup to get a session token.
 */
export async function createSession(): Promise<void> {
  await publicFetch("/auth/session", {
    method: "POST",
  });
}
